import { Badge, Button } from '@eleveo/components-react';
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDateFormatter } from 'react-aria';

export type WeekDayTileProps = {
  active: boolean;
  dataTestId?: string;
  dayOfWeek: Date;
  isDuplicationActive: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  selected: boolean;
  valid: boolean;
};

export const WeekDayTile: React.FC<WeekDayTileProps> = ({
  active,
  dataTestId,
  dayOfWeek,
  isDuplicationActive,
  onClick,
  selected,
  valid,
}) => {
  const dayFormatter = useDateFormatter({
    weekday: 'short',
  });

  return (
    <Badge color="success" isInvisible={!valid} alignment="center" variant="dot">
      <Button
        isDisabled={isDuplicationActive && active}
        isSelected={active || selected}
        isSmall
        onClick={onClick}
        variant="outline"
        testId={dataTestId}
      >
        {dayFormatter.format(dayOfWeek)}
      </Button>
    </Badge>
  );
};
